<template>
  <PageLayout>
    <PageHeader :title="$t(`Common.title.homeTitle`)" :breadcrumb="[
      { title: $t(`Common.title.homeTitle`) },
      {
        title: $t(`Common.title.${this.$route.params?.type}`),
      },
      {
        title: $t('apply.title.penaltyInfo2'),
      },
    ]" />

    <div class="pl-2">
      <!-- 基本信息 -->
      <m-card :title="$t(`apply.title.penaltyInfo`)">
        <ErrorTips
          v-if="!autoCaseData.paymentFlag && `已支付` != autoCaseData.paymentFlagInfo && autoCaseData.paymentFlagInfo"
          :title="autoCaseData.paymentFlagInfo" />

        <div :style="{
          'flex-direction': isLargeScreen ? 'row' : 'column',
          display: 'flex',
        }">
          <m-cell>
            <m-cell-item :label="$t('apply.title.offender')" :value="autoCaseData.cName || `-`"></m-cell-item>
            <m-cell-item :label="$t('apply.title.IDNumber6')" :value="autoCaseData.docNo || `-`"></m-cell-item>
            <m-cell-item :label="$t('apply.title.liveNumber')"
              :value="autoCaseData.autoNo + '/' + autoCaseData.illegalYear">

            </m-cell-item>
            <m-cell-item :label="$t('apply.title.incidentDate')" :value="autoCaseData.autoDate"></m-cell-item>
            <m-cell-item :label="$t('apply.title.incidentLocation')" :value="autoCaseData.portName"></m-cell-item>
            <m-cell-item :label="$t('apply.title.stage')" :value="autoCaseData.statusDesc1"></m-cell-item>

            <m-cell-item :label="$t('apply.title.illegalItems')" :value="formattedAutoNo" />
            <m-cell-item :label="$t('apply.title.illegalRegulations')">
              <template slot="value">
                <div v-html="formattedlawDescText2" />
              </template>
            </m-cell-item>

            <div v-if="showAmount">
              <m-cell-item :label="$t('apply.title.penaltyAmount')" :value="`${$t(`mo_dollar`)} ${formatMoney(autoCaseData.totalPenalAmount)
                }`"></m-cell-item>

              <m-cell-item :label="$t('apply.title.paidAmount')" :value="`${$t(`mo_dollar`)} ${formatMoney(autoCaseData.totalAmountPaid)
                }`"></m-cell-item>

              <m-cell-item :label="$t('apply.title.outstandingAmount')" :value="`${$t(`mo_dollar`)} ${formatMoney(autoCaseData.owedTotalAmount)
                }`"></m-cell-item>
            </div>


            <m-cell-item v-if="autoCaseData.finishPaymentResult" :label="$t('apply.title.finishPaymentResult')" :value="autoCaseData.finishPaymentResult == 'Y'
              ? $t('paySuccess')
              : autoCaseData.finishPaymentResult
              "></m-cell-item>
          </m-cell>
        </div>
      </m-card>
    </div>

    <PaymentConfirmModal :refreshPay="startPolling" :visible.sync="payVisible" @close="payVisible = false"
      :data="searchData">
    </PaymentConfirmModal>

    <template slot="actions">
      <div class="m-page-footer">
        <m-button block type="primary" ghost size="large" @click="onClose" class="m-footer_button">
          {{
            $t('Common.action.backHome')
          }}
        </m-button>
        <m-button block type="primary" ghost size="large" @click="downloadVoucher" class="m-footer_button">
          {{ $t('Common.action.downloadVoucher') }}
        </m-button>

        <m-button block v-if="application?.applicationNo && application?.status == 'FINISHED'" type="primary"
          size="large" @click="downloadReceipts" class="m-footer_button">
          {{ $t("Common.action.downloadReceipts") }}
        </m-button>

        <m-button block type="primary" v-if="
          autoCaseData.desDate != null &&
          autoCaseData.paymentFlag &&
          autoCaseData.owedTotalAmount > 0 &&
          autoCaseData.finance !== 'Y'
        " size="large" @click="onPay" class="m-footer_button">
          {{ $t('Common.action.pay') }}
        </m-button>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/PageLayout.vue';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';
import PaymentConfirmModal from './modal/PaymentConfirmModal.vue';
import WindowMixins from 'govmo-common/src/mixins/WindowMixins';
import { ApplicationAPI } from 'govmo-common/src/api';
import { downloadFile } from 'govmo-common/src/utils/utils';
import ErrorTips from 'common/components/Error/ErrorTips.vue';

export default {
  mixins: [WindowMixins],
  components: {
    PageLayout,
    PageHeader,
    PaymentConfirmModal,
    ErrorTips
  },
  computed: {

    showAmount() {
      return this.autoCaseData.desDate != null && ["4", "5", "8", "9"].includes(this.autoCaseData.idsts);
    },
    formattedAutoNo() {
      const { autoNo, illegalYear } = this.autoCaseData || {};
      return this.$t('in_auto_no', {
        content: (autoNo || '') + '/' + (illegalYear || '')
      });
    },
    formattedlawDescText2() {
      return this.autoCaseItems.map((item) => item.lawDescText2).join("<br/>");
    },
  },
  data() {
    return {
      searchData: null,
      autoCaseData: {},
      application: {},
      autoCaseItems: [],
      result: null,
      payVisible: false,
      transactionNo: null,
    };
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    formatMoney(value) {
      return value ? Number(value).toFixed(1) : '0';
    },
    async getSearchData() {
      try {

        this.$showLoading();
        const {
          docNo = '',
          autoNo = '',
          illegalYear = '',
          expire = '',
          signature = '',
        } = this.$route.query;

        const params = { docNo, autoNo, illegalYear, expire, signature };
        const { autoCaseData, autoCaseItems, result, application } = await ApplicationAPI.getSignDetails(params);
        this.autoCaseData = autoCaseData;
        this.application = application;
        this.autoCaseItems = autoCaseItems;
        this.result = result;
        this.searchData = { docNo, autoNo, illegalYear };
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    onClose() {
      this.$router.push('/');
    },
    async downloadVoucher() {
      this.$showLoading();

      try {
        const { expire = "", signature = "" } = this.$route.query;

        const res = await ApplicationAPI.downloadPDF({
          illegalYear: this.autoCaseData.illegalYear,
          autoNo: this.autoCaseData.autoNo,
          docNo: this.autoCaseData.docNo,
          expire: expire,
          signature: signature,
        });
        downloadFile(res)
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },

    async downloadReceipts() {
      if (!this.application?.applicationNo) {
        return;
      }

      this.$showLoading();
      const { expire = "", signature = "" } = this.$route.query;
      try {
        const res = await ApplicationAPI.downloadReceipts(
          {
            illegalYear: this.autoCaseData.illegalYear,
            autoNo: this.autoCaseData.autoNo,
            docNo: this.autoCaseData.docNo,
            expire: expire,
            signature: signature,
          });
        downloadFile(res);
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    onPay() {
      if (!this.autoCaseData.paymentFlag) {
        this.$error(this.autoCaseData.paymentFlagInfo);
        return;
      }

      this.payVisible = true;
    },
    startPolling(transactionNo) {
      this.checkedPayResults(transactionNo)
      this.timer = setInterval(() => {
        this.checkedPayResults(transactionNo)
      }, 5000)
    },

    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    reloadPage() {
      this.getSearchData()
      this.stopPolling();
    },
    async checkedPayResults(transactionNo) {
      if (transactionNo) {
        try {
          this.$showLoading(this.$t('loadingMessage'));
          const { code } = await ApplicationAPI.checkedPaymentResult(transactionNo)
          if (code == 'PAYMENT_SUCCESS' || code == 'PAYMENT_EXPIRED') {
            this.reloadPage()
          }
        } catch (error) {
          const message = this.$errorMessage(error);
          if (message == this.$t(`ERROR_CODE_MESSAGE.CASE_NOT_FOUND`)) {
            this.reloadPage()
          }
        }
      }
    },
  },
  async created() {
    this.getSearchData();
    this.startPolling()
  },
};
</script>
<style lang="scss" scoped>
@import '@/meta-variables.scss';

::v-deep .ant-card-head {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 16px;
  color: #fff;
  font-size: 18px;
  background: var(--m-primary-color);
  border-radius: 10px 10px 0 0;
  zoom: 1;
}

.m-page-footer {
  display: flex;
  flex-direction: row;
}

.m-footer_button {
  margin-left: 8px;
}

@media screen and (max-width: 576px) {
  ::v-deep(.web-page__content.has-footer) {
    padding-bottom: 8px;
  }

  .m-footer_button {
    margin-bottom: 8px;
    margin-left: 0;
  }

  ::v-deep(.web-page-actions__content) {
    justify-content: center;
    display: contents;
  }

  .m-page-footer {
    display: flex;
    flex-direction: column;
  }
}
</style>
